import ReactDOM from "react-dom/client";

import { App } from "./App";
import { NkuliAuthProvider } from "./auth/NkuliAuthProvider";
import { createConvexClient } from "./lib/convex";
import { getBrowserEnvironment } from "./config/environment";
import "@fontsource/jockey-one";
import "./index.css";
import "./workspace/workspace.css";
import "./workspace/workspace-overview.css";
import "./workspace/inbox-workspace.css";
import "./customers/customers.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("The application root element is missing.");
}

try {
  const environment = getBrowserEnvironment();
  const convexClient = createConvexClient(environment.convexUrl);

  ReactDOM.createRoot(rootElement).render(
    <NkuliAuthProvider client={convexClient}>
      <App />
    </NkuliAuthProvider>,
  );
} catch (error) {
  const message =
    error instanceof Error ? error.message : "Unknown configuration error.";
  const shell = document.createElement("main");
  const heading = document.createElement("h1");
  const description = document.createElement("p");

  shell.className = "foundation-shell";
  description.className = "description";
  heading.textContent = "Configuration required";
  description.textContent = message;

  shell.append(heading, description);
  rootElement.replaceChildren(shell);
}
